import PageNotFound from "../components/PageNotFound";
export default function Page404() {
    return(
            <>
                <PageNotFound />
            </>
    );
}
